import {SvgIcon} from '@mui/material';
import MainLinearGradient from './MainLinearGradient';

export default function CharityServiceIcon(props: { color?: string; }) {
	const {color = 'url(#paint0_linear_1074_1945)'} = props;
	return (
		<SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none">
			<path opacity="0.4"
			      d="M26.6253 13.3334V24C26.6253 28 25.292 29.3334 21.292 29.3334H10.6253C6.62533 29.3334 5.29199 28 5.29199 24V13.3334H26.6253Z"
			      fill={color}/>
			<path
				d="M28.6668 9.33329V10.6666C28.6668 12.1333 27.9602 13.3333 26.0002 13.3333H6.00016C3.96016 13.3333 3.3335 12.1333 3.3335 10.6666V9.33329C3.3335 7.86663 3.96016 6.66663 6.00016 6.66663H26.0002C27.9602 6.66663 28.6668 7.86663 28.6668 9.33329Z"
				fill={color}/>
			<path opacity="0.4"
			      d="M15.5186 6.66801H8.15859C7.93936 6.43022 7.821 6.11661 7.82846 5.79326C7.83592 5.46992 7.96862 5.1621 8.19859 4.93468L10.0919 3.04134C10.3315 2.8044 10.6549 2.67151 10.9919 2.67151C11.3289 2.67151 11.6523 2.8044 11.8919 3.04134L15.5186 6.66801ZM23.8293 6.66801H16.4693L20.0959 3.04134C20.3355 2.8044 20.6589 2.67151 20.9959 2.67151C21.3329 2.67151 21.6563 2.8044 21.8959 3.04134L23.7893 4.93468C24.2693 5.41468 24.2826 6.17468 23.8293 6.66801Z"
			      fill={color}/>
			<path opacity="0.6"
			      d="M11.9214 13.3334V20.1867C11.9214 21.2534 13.0947 21.88 13.9881 21.3067L15.2414 20.48C15.4591 20.3367 15.714 20.2603 15.9747 20.2603C16.2354 20.2603 16.4903 20.3367 16.7081 20.48L17.8947 21.28C18.095 21.4135 18.3277 21.4901 18.5681 21.5017C18.8084 21.5133 19.0474 21.4594 19.2596 21.3458C19.4717 21.2322 19.6491 21.0632 19.7727 20.8567C19.8963 20.6502 19.9615 20.414 19.9614 20.1734V13.3334H11.9214Z"
			      fill={color}/>
			<defs>
				<linearGradient id="paint0_linear_1074_1945" x1="26.17" y1="13.3334" x2="4.31178" y2="14.8085"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
